import src from "IMAGE";
export default { src, width: 12, height: 23, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
